import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-east-2_NmirStGBk',
    ClientId: '6vd3e82pmjaqrfb4uieops2l5m'
};

export default new CognitoUserPool(poolData);